import { render, staticRenderFns } from "./Trainingsplan.vue?vue&type=template&id=daf884a0&scoped=true&"
import script from "./Trainingsplan.vue?vue&type=script&lang=js&"
export * from "./Trainingsplan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daf884a0",
  null
  
)

export default component.exports